import styles from "../superBrands.module.scss";
import { useState } from "react";
import Srcset from "@/components/common/Srcset";
import CTA from "@/components/common/CTA";
export default function StoryCard(props) {
  const [cardOpen, setIsCardOpen] = useState(true);
  const handleCard = () => {
    setIsCardOpen(!cardOpen);
  };
  const backgroundColorClass = props.storyTellingBackgroundColor
    ? "bg-" + props.storyTellingBackgroundColor.toLowerCase()
    : "";

  return (
    <>
      <div
        className={
          cardOpen
            ? `${styles.storycard} ${styles.full_width}`
            : `${styles.storycard}`
        }
      >
        <div className={`${styles.text_block} ${backgroundColorClass}`}>
          <div
            className={styles.back_arrow}
            onClick={() => props.handleClick(false, props.index)}
          >
            <Srcset
              requirePath={true}
              svgFile={true}
              src={"images/Icons/Arrow/Right/large.svg?imbypass=true"}
              alt="back button"
              height="16"
              width="19.11"
            />
          </div>
          <div className={`${styles.header_wrapper}`}>
            <h3 className={`heading-350 ${styles.mobile_width}`}>
              {props.storyTellingHeader}
            </h3>
            <div
              className={styles.mobile_close}
              onClick={() => props.handleClick(false, props.index)}
            >
              <Srcset
                requirePath={true}
                svgFile={true}
                src={"images/Icons/Cross/Large.svg"}
                alt="cross-button"
                height="14"
                width="14"
              />
            </div>
          </div>
          <div
            className={`x-small-xs small-sm large-md ${styles.body_wrapper}`}
          >
            {props.storyTellingBody}
          </div>
          <div className={styles.cta_wrapper}>
            <CTA
              text={props.storyTellingCtaText}
              link={props.storyTellingCtaUrl}
              sizeClass="normal-md x-small-sm x-small-xs"
            />
          </div>
        </div>
        <div className={styles.image_block}>
          <Srcset src={props.storyTellingImage} height="100%" width="100%" alt={props.storyTellingHeader}/>
        </div>
      </div>
    </>
  );
}
